import { Chip } from '@mui/material';
import { useCopy } from '@/hooks/useCopy';

/**
 * SASADM-0170 — the text cue that something is turned off (A11Y-005). Always shown next to
 * `DISABLED_TEXT_SX`: strikethrough and grey alone are not enough.
 */
export function DisabledChip() {
  const { t } = useCopy();
  return <Chip size="small" variant="outlined" label={t('common.disabled', 'Disabled')} />;
}
